import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Fade from 'react-reveal/Fade'

import styles from './styles.scss'

const ColumnTwo = (props) => {
  const {
    bodyText, greyBackground, imageUrl, reversed, title,
  } = props

  return (
    <div className={reversed ? classnames(styles.root, styles.reversed) : styles.root}>
      <div className={classnames(styles.column, greyBackground ? styles.grey : null)}>
        <Fade bottom>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.bodyText}>{bodyText}</p>
        </Fade>
      </div>

      <div className={styles.column} style={{ backgroundImage: `url(${imageUrl})` }} />
    </div>
  )
}

ColumnTwo.propTypes = {
  bodyText: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]).isRequired,
  greyBackground: PropTypes.bool,
  imageUrl: PropTypes.string.isRequired,
  reversed: PropTypes.bool,
  title: PropTypes.string.isRequired,
}

export default ColumnTwo
